import React from "react";
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { Router, Route, Switch } from "react-router-dom";
import "assets/vendors/style";
import "styles/wieldy.less";
// import "styles/fontawesome.css";
// import "styles/layout.css"; //切换为在main区域滚动
import "styles/layout-fix.css"; //切换为在body滚动
import "styles/site.css";

import configureStore, { history } from './appRedux/store';
import App from "./containers/App/index";
import { AuthProvider } from "./authentication";
import { Modal } from 'antd';
import moment from 'moment';

const store = configureStore();

//设置周一为第一天
moment.locale('en',{
  week: {
      dow: 1
  },
})

const NextApp = () =>
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <AuthProvider>
        <Switch>
          <Route path="/" component={App} />
        </Switch>
      </AuthProvider>
    </ConnectedRouter>
  </Provider>;
export default NextApp;

// window.onerror = (msg, url, line, col, error) => {
//   // Note that col & error are new to the HTML 5 spec and may not be
//   // supported in every browser.  It worked for me in Chrome.
//   console.log('Global Error');
//   let extra = !col ? '' : '<br>column: ' + col;
//   extra += !error ? '' : '<br>error: ' + error;

//   let errorText = 'Error: ' + msg + '<br>url: ' + url + '<br>line: ' + line + extra;
//   console.log(errorText);
//   // Modal.error({
//   //   title: 'Error',
//   //   content: (<span className='full-in-parent' dangerouslySetInnerHTML={{ __html: errorText }} />),
//   //   width: 1000
//   // });

//   var suppressErrorAlert = true;
//   // If you return true, then error alerts (like in older versions of
//   // Internet Explorer) will be suppressed.
//   return suppressErrorAlert;
// };
